/**
 * @file mapVendor.js
 * @description Translate between the AddVendorModal form shape (client-style
 * fields) and the backend vendor payload shape. Kept out of the modal so the
 * modal stays presentation-only.
 */

const BALANCE_TYPE_TO_API = {
  you_owe: "you_owe_vendor",
  owes_you: "vendor_owes_you",
};

const BALANCE_TYPE_FROM_API = {
  you_owe_vendor: "you_owe",
  vendor_owes_you: "owes_you",
};

/** Modal form → backend create/update payload. */
export const mapFormToVendorPayload = (form) => {
  const openingBalance =
    form.openingBalance !== null &&
    form.openingBalance !== undefined &&
    form.openingBalance !== ""
      ? Number(form.openingBalance)
      : 0;

  const hasBalance = openingBalance > 0;

  return {
    name: (form.name || "").trim(),
    displayName: (form.additionalDetail || form.name || "").trim(),
    email: form.email || "",
    phone: form.contact || "",
    vatNumber: form.taxNumber || "",
    address: form.address ? { street: form.address } : {},
    openingBalance,
    balanceType: hasBalance
      ? BALANCE_TYPE_TO_API[form.balanceType] || "none"
      : "none",
    notes: form.taxName ? `Tax name: ${form.taxName}` : "",
    currency: "SAR",
  };
};

/** Backend vendor → modal form (for edit prefill). */
export const mapVendorToForm = (vendor) => ({
  id: vendor.id || vendor._id,
  salutation: "",
  name: vendor.name || "",
  additionalDetail:
    vendor.displayName && vendor.displayName !== vendor.name
      ? vendor.displayName
      : "",
  contact: vendor.phone || "",
  email: vendor.email || "",
  taxName: "",
  taxNumber: vendor.vatNumber || "",
  address:
    typeof vendor.address === "string"
      ? vendor.address
      : vendor.address?.street || "",
  openingBalance:
    vendor.openingBalance !== null && vendor.openingBalance !== undefined
      ? String(vendor.openingBalance)
      : "",
  openingDate: vendor.openingDate || new Date().toISOString().split("T")[0],
  balanceType: BALANCE_TYPE_FROM_API[vendor.balanceType] || "you_owe",
});
